import { gql } from '@common/hooks';
import {
  AssignmentState,
  ComplianceAssignmentFragmentType,
} from '@onboarding/graphql/fragments';

export const ComplianceAssignmentsQuery = gql`
  query ComplianceAssignmentsQuery(
    $id: ID!
    $state: [StaffingRequestAssignmentState!]
  ) {
    worksListTemplate(id: $id) {
      id
      name
    }
    staffingRequestAssignments(state: $state) {
      id
      supplier {
        id
        name
      }
      worksList {
        id
        name
        worksListTemplate {
          id
        }
      }
      organizationUnit {
        id
        name
        costCenter
      }
      worksProfile {
        id
        fullName
      }
      state
    }
  }
`;

export type ComplianceAssignmentsQueryResponse = {
  staffingRequestAssignments: ComplianceAssignmentFragmentType[];
  worksListTemplate: {
    id: string;
    name: string;
  };
};

export type ComplianceAssignmentsQueryArgs = {
  id: string;
  state: AssignmentState[];
};
